import React from 'react';
import { Skeleton } from '@heroui/react';

const NftCardLoader = () => {
  return (
    <>
      <div
        className="cursor-pointer rounded-2xl h-[26rem] lg:h-[25.25rem] border-[0.75rem] border-black relative z-1 flex flex-col"
      >
        <Skeleton className="w-full h-full rounded-md absolute inset-0 z-[-1]"></Skeleton>
        <div className='p-2 mt-[auto] w-full'>
          <div className='bg-black p-3 rounded-lg flex flex-col gap-3'>
            <Skeleton className="dark w-full h-6 rounded-md"></Skeleton>
            <div className='flex items-center gap-2'>
              <Skeleton className="dark w-24 h-4 rounded-md"></Skeleton>
              <Skeleton className="dark w-16 h-3 rounded-md"></Skeleton>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default NftCardLoader;
